import { useAnalyticsContext } from 'providers/AnalyticProvider';
import { useCallback } from 'react';
import { PAGINATION_INTERACTION } from 'constants/analyticEvents';
import usePageInfo from './usePageInfo';

const useSendPaginationGAEvent = () => {
  const analytics = useAnalyticsContext();
  const { moduleName, pageName } = usePageInfo();

  const sendPaginationEvent = useCallback(
    (sectionName, tableName, pageNumber) => {
      const currentPage = pageNumber + 1;
      if (sectionName && currentPage && tableName) {
        analytics?.sendGAEvent(PAGINATION_INTERACTION, {
          page_number: currentPage,
          table_name: tableName,
          section_name: sectionName,
          module_name: moduleName,
          page_name: pageName,
        });
      }
    },
    [analytics, moduleName, pageName],
  );

  return sendPaginationEvent;
};

export default useSendPaginationGAEvent;
